import { Route, Navigate, Routes as RouterRoutes } from "react-router-dom";
import Directories from "../pages/Directories";
import AddDirectory from "../pages/Directories/Add";
import Directory from "../pages/Directories/Directory";
import EditDirectory from "../pages/Directories/Edit";
import Events from "../pages/Events";
import AddEvent from "../pages/Events/Add";
import EditEvent from "../pages/Events/Edit";
import Event from "../pages/Events/Event";
import Games from "../pages/Games";
import Locations from "../pages/Locations";
import Home from "../pages/Home";
import AddLocation from "../pages/Locations/Add";
import EditLocation from "../pages/Locations/Edit";
import Login from "../pages/Login";
import TenantCommunityInbox from "../pages/TenantCommunityInbox";
import AddTenantCommunityInboxPost from "../pages/TenantCommunityInbox/Add";
import EditTenantCommunityInboxPost from "../pages/TenantCommunityInbox/Edit";

import { Routes } from "./Routes";

const Navigation = () => {
  return (
    <RouterRoutes>
      <Route path={Routes.login} element={<Login />} />
      <Route path={Routes.home} element={<Home />} />
      <Route path={Routes.events} element={<Events />} />

      <Route path={Routes.event} element={<Event />} />

      <Route path={Routes.addEvent} element={<AddEvent />} />
      <Route path={Routes.editEvent} element={<EditEvent />} />

      <Route path={Routes.directories} element={<Directories />} />
      <Route path={Routes.directory} element={<Directory />} />

      <Route path={Routes.addDirectory} element={<AddDirectory />} />
      <Route path={Routes.editDirectory} element={<EditDirectory />} />

      <Route path={Routes.games} element={<Games />} />

      <Route path={Routes.game} element={<Locations />} />
      <Route path={Routes.addLocation} element={<AddLocation />} />
      <Route path={Routes.editLocation} element={<EditLocation />} />

      <Route path={Routes.tenantCommunityInbox} element={<TenantCommunityInbox />} />
      <Route
        path={Routes.addTenantCommunityInboxPost}
        element={<AddTenantCommunityInboxPost />}
      />
      <Route
        path={Routes.editTenantCommunityInboxPost}
        element={<EditTenantCommunityInboxPost />}
      />

      <Route path="*" element={<Navigate to={Routes.home} replace />} />
    </RouterRoutes>
  );
};
export default Navigation;
